import { Component, OnInit, OnDestroy } from '@angular/core'
import { CheckoutService } from '../../checkout.service'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { Subscription } from 'rxjs'
import { ActiveCartFacade } from '@spartacus/cart/base/root'

@Component({
  standalone: false,
  selector: 'vs-shiping',
  templateUrl: './shiping.component.html',
  styleUrls: ['./shiping.component.scss'],
})
export class ShipingComponent implements OnInit, OnDestroy {
  public cartOrderReviewObj: any
  specialInstructionData = []
  confirmShip: any
  cartId: any
  activeCartIdSubscription: Subscription

  constructor(
    private checkoutService: CheckoutService,
    public activeCartService: ActiveCartFacade,
    private globalMessageService: GlobalMessageService
  ) {
    this.activeCartIdSubscription = this.activeCartService
      .getActiveCartId()
      .subscribe(
        (success) => {
          if (success) {
            this.cartId = success
            this.checkoutService
              .fetchSpecialInstructionData(this.cartId)
              .subscribe(
                (data) => {
                  this.specialInstructionData = data['specialInstructionsList']
                },
                (error) => {
                  this.globalMessageService.add(
                    error,
                    GlobalMessageType.MSG_TYPE_ERROR,
                    5000
                  )
                  window.scrollTo(0, 0)
                }
              )

            this.checkoutService.getCartReviewOrderResponse.subscribe(
              (success) => {
                this.cartOrderReviewObj = success
              },
              (error) => {
                this.globalMessageService.add(
                  error,
                  GlobalMessageType.MSG_TYPE_ERROR,
                  5000
                )
                window.scrollTo(0, 0)
              }
            )
          }
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  ngOnDestroy(): void {
    if (this.activeCartIdSubscription) {
      this.activeCartIdSubscription.unsubscribe()
    }
  }

  ngOnInit(): void {
    this.checkoutService.specialInstructionObj.subscribe(
      (data) => {
        //this.cartOrderReviewObj = data;
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    this.confirmShip = this.checkoutService.getShpCodes()
  }
}
